import React from 'react'

const IncomeChart = ({ data }) => {
  const incomeRanges = [
    '$0 - $2k',
    '$3 - $5k',
    '$6 - $8k',
    '$9 - $10',
    '$10 - $15k',
    '$16 - $20k',
  ]

  const incomeCounts = incomeRanges.reduce((acc, range) => {
    acc[range] = 0
    return acc
  }, {})

  data.forEach((d) => {
    const income = d['Income/Month']?.trim()
    if (income && incomeCounts.hasOwnProperty(income)) {
      incomeCounts[income]++
    }
  })

  const total = Object.values(incomeCounts).reduce((sum, val) => sum + val, 0)

  const percentages = incomeRanges.map((range) => ({
    label: range,
    value: total ? ((incomeCounts[range] / total) * 100).toFixed(0) : 0,
  }))

  return (
    <div className="bg-white rounded shadow p-4 w-full">
      <h2 className="font-semibold text-sm text-gray-700 mb-4">INCOME</h2>
      <div className="space-y-4">
        {percentages.map(({ label, value }) => (
          <div key={label}>
            <div className="flex justify-between mb-1">
              <span className="text-sm text-gray-700">{label}</span>
              <span className="text-sm font-bold text-gray-900">{value}%</span>
            </div>
            <div className="w-full bg-gray-200 h-2 rounded">
              <div
                className="bg-sky-400 h-2 rounded"
                style={{ width: `${value}%` }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default IncomeChart
